import { normalizeFabricEvent } from "../nexus/livingData";

const EVENT_NAME = "hqs:fabric-event";
const CHANNEL_NAME = "hqs:nexus-fabric:v1";

function createChannel() {
  if (typeof window === "undefined" || typeof BroadcastChannel === "undefined") return null;
  try {
    return new BroadcastChannel(CHANNEL_NAME);
  } catch {
    return null;
  }
}

export function emitNexusFabricEvent(input) {
  if (typeof window === "undefined") return null;
  const event = normalizeFabricEvent(input);
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: event }));
  const channel = createChannel();
  if (channel) {
    try {
      channel.postMessage(event);
    } finally {
      channel.close();
    }
  }
  return event;
}

export function subscribeNexusFabricEvents(listener) {
  if (typeof window === "undefined" || typeof listener !== "function") return () => {};
  const handleWindowEvent = (event) => listener(normalizeFabricEvent(event.detail));
  const channel = createChannel();
  const handleChannelEvent = (event) => listener(normalizeFabricEvent(event.data));
  window.addEventListener(EVENT_NAME, handleWindowEvent);
  channel?.addEventListener("message", handleChannelEvent);
  return () => {
    window.removeEventListener(EVENT_NAME, handleWindowEvent);
    channel?.removeEventListener("message", handleChannelEvent);
    channel?.close();
  };
}
